import OffcanvasNovoDadoRoot from "./OffcanvasNovoDadoRoot";
import OffcanvasNovoDadoHeader from "./OffcanvasNovoDadoHeader";
import OffcanvasNovoDadoBody from "./OffcanvasNovoDadoBody";

export const OffcanvasNovoDado = {
    Root: OffcanvasNovoDadoRoot,
    Header: OffcanvasNovoDadoHeader,
    Body: OffcanvasNovoDadoBody,
};
